import React from 'react'
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';

const HomeSection2 = ({ section2, section2InView, i18n }) => {
  return (
    <section style={Number(section2.use_bg_color) === 1 && section2.bg_color1 && section2.bg_color2 ? { background: `linear-gradient(to right, ${section2.bg_color1}, ${section2.bg_color2})` } : {}}>
      <div className="container mt-5">
          <div className="row py-4" style={{ margin: "20px !important" }}>
            <motion.div className="col-12 col-lg-6 me-5 p-5"
              style={{ boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)", borderRadius: "30px" }} data-aos="fade-right"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.75 }}>
              <h2>{i18n.language === "en" ? section2.titlecard1En : section2.titlecard1Ar}</h2>
              <p>{i18n.language === "en" ? section2.paragraphcard1En : section2.paragraphcard1Ar}</p>
           <NavLink to="/about"> <button className="hero-button">{i18n.language === "en" ? section2.btncardEn : section2.btncardAr}</button> </NavLink>  
            </motion.div>
            <motion.div className="col-12 col-lg-5 mt-5 mt-lg-0 p-5"
              style={{ boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)", borderRadius: "30px" }} data-aos="fade-right"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.75 }}>
              <h2>{i18n.language === "en" ? section2.titlecard2En : section2.titlecard2Ar}</h2>
              <p>{i18n.language === "en" ? section2.paragraphcard2En : section2.paragraphcard2Ar}</p>
            </motion.div>
          </div>
      </div>
    </section>
  )
}

export default HomeSection2
